/**
 * Frontend accordion toggle for FAQ Single block.
 */
const initFaqSingle = () => {
	document.querySelectorAll( '.wp-block-mdny-blocks-faq-single' ).forEach( ( faqEl ) => {
		if ( faqEl.dataset.faqBound === 'true' ) {
			return;
		}

		const button = faqEl.querySelector( '.read-ans-btn' );
		const answer = faqEl.querySelector( '.faq-ans' );

		if ( ! button || ! answer ) {
			return;
		}

		faqEl.dataset.faqBound = 'true';

		button.addEventListener( 'click', () => {
			const isOpen = faqEl.classList.toggle( 'is-open' );

			button.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );

			if ( isOpen ) {
				answer.style.height = `${ answer.scrollHeight }px`;
			} else {
				answer.style.height = '0px';
			}
		} );
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initFaqSingle );
} else {
	initFaqSingle();
}
